document.addEventListener('DOMContentLoaded', () => {
  // Helper function to handle form submission
  function submitLocalizationForm({ country, language }) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.style.display = 'none';

    const inputs = `
      <input type="hidden" name="_method" value="PUT">
      ${country ? `<input type="hidden" name="country_code" value="${country}">` : ''}
      ${language ? `<input type="hidden" name="language_code" value="${language}">` : ''}
      <input type="hidden" name="return_to" value="${window.location.pathname}">
    `;
    
    form.innerHTML = inputs;
    document.body.appendChild(form);
    form.submit();
  }

  // Get user's location using Shopify's endpoint
  async function getLocation() {
    try {
      const response = await fetch('/browsing_context_suggestions.json');
      const data = await response.json();
      return {
        country: data.detected_values.country.handle,
        language: data.detected_values.language.handle
      };
    } catch (shopifyError) {
      // Fallback to freeipapi if Shopify endpoint fails
      try {
        const response = await fetch("https://freeipapi.com/api/json/");
        const data = await response.json();
        return {
          country: data.countryCode,
          language: data.countryCode === 'FR' ? 'fr' : 'en'
        };
      } catch (error) {
        console.error('Error fetching location:', error);
        return { country: 'US', language: 'en' };
      }
    }
  }

  // Check if this is a new session
  function isNewSession() {
    return !sessionStorage.getItem('sessionStarted');
  }

  // Initialize currency selectors
  function initializeCurrencySelectors(defaultCountry) {
    const savedCountry = sessionStorage.getItem('country') || defaultCountry;

    document.querySelectorAll('.currency-selector select').forEach(select => {
      select.value = savedCountry;
      
      select.addEventListener('change', () => {
        const selectedCountry = select.value;
        sessionStorage.setItem('country', selectedCountry);
        submitLocalizationForm({ country: selectedCountry });
      });
    });
  }

  // Initialize language selectors
  function initializeLanguageSelectors(defaultLanguage) {
    const savedLanguage = localStorage.getItem('language') || defaultLanguage;
    
    document.querySelectorAll('.language-selector button').forEach(button => {
      const buttonLang = button.getAttribute('data-language');
      button.classList.toggle('active', buttonLang === savedLanguage);
      
      button.addEventListener('click', () => {
        const selectedLanguage = button.getAttribute('data-language');
        localStorage.setItem('language', selectedLanguage);
        submitLocalizationForm({ language: selectedLanguage });
      });
    });
  }

  // Show all localization wrappers
  function showLocalizationWrappers() {
    document.querySelectorAll('.localization-wrapper').forEach(wrapper => {
      wrapper.classList.add('is-visible');
    });
  }

  // Initialize everything
  async function initialize() {
    const location = await getLocation();
    const savedLanguage = localStorage.getItem('language');
    
    // If this is a new session...
    if (isNewSession()) {
      sessionStorage.setItem('sessionStarted', 'true');
      
      // Always reset country/currency to detected location
      sessionStorage.setItem('country', location.country);
      
      // If we have a saved language preference, use it, otherwise use detected language
      const languageToUse = savedLanguage || location.language;
      if (!savedLanguage) {
        localStorage.setItem('language', languageToUse);
      }

      // Submit form with both country and language
      submitLocalizationForm({ 
        country: location.country,
        language: languageToUse
      });
      
      // Return early as the page will refresh
      return;
    }
    
    // Not a new session, initialize everything normally
    if (!sessionStorage.getItem('country')) {
      sessionStorage.setItem('country', location.country);
    }
    
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', location.language);
    }

    initializeCurrencySelectors(location.country);
    initializeLanguageSelectors(location.language);
    showLocalizationWrappers();
  }

  initialize();
});